import App from '../App.vue'

export default  {
    path: '/user',
    component: App,
    meta: { title: '个人中心' },
    children:[
        {
            path: 'info/edit',
            component: () => import('../views/User/EditUserInfo.vue'),
            meta: {
                title: '个人信息管理',
            }
        },
        {
            path: 'registration/list',
            component: () => import('../views/User/ListRegistration.vue'),
            meta: {
                title: '参会人管理',
            }
        },
        {
            path: 'registration/new',
            component: () => import('../views/User/NewRegistration.vue'),
            meta: {
                title: '添加参会人',
            }
        },
        {
            path: 'registration/edit/:registrationID',
            component: () => import('../views/User/EditRegistration.vue'),
            meta: {
                title: '编辑参会人',
            }
        },
        {
            path: 'credit-info/list',
            component: () => import('../views/User/ListCreditInfo.vue'),
            meta: {
                title: '学分信息管理',
            }
        },
        {
            path: 'credit-info/new',
            component: () => import('../views/User/NewCreditInfo.vue'),
            meta: {
                title: '添加学分信息',
            }
        },
        {
            path: 'credit-info/edit/:creditInfoID',
            component: () => import('../views/User/EditCreditInfo.vue'),
            meta: {
                title: '编辑学分信息',
            }
        },
        {
            path: 'invoice-info/list',
            component: () => import('../views/User/ListInvoiceInfo.vue'),
            meta: {
                title: '发票信息管理',
            }
        },
        {
            path: 'invoice-info/new',
            component: () => import('../views/User/NewInvoiceInfo.vue'),
            meta: {
                title: '添加发票信息',
            }
        },
        {
            path: 'invoice-info/edit/:invoiceInfoID',
            component: () => import('../views/User/EditInvoiceInfo.vue'),
            meta: {
                title: '管理发票信息',
            }
        },
        {
            path: 'order-meeting-certificate/list',
            component: () => import('../views/User/ListOrderMeetingCertificate.vue'),
            meta: {
                title: '我的证书列表',
            }
        },
    ]
}